'use strict';

import { isLoadedFromRefresh, appState } from './appState.js';
import { ajaxWrapNew, CommandRegistry, ResponseDispatcher } from './ajaxWrapNew.js';
import { VarMgr } from './VarMgr.js';
import { setUrlParam, urlSafe } from './urlTools.js';
import { lmAppStorage } from './lmAppStorage.js';
import { optionsMenu } from './optionsMenu.js';
import { scrollToElement, setScroll } from './Scrolls.js';
import { togglableUrl } from './togglableUrl.js';
import { ModalManager } from './ModalManager.js';
import { ActionSets } from './ActionSets.js';
import { getUserTime } from './Times.js';
import { minimizableInit } from './minimizable.js';
import { ChatBoxEditable, createOutclickerOverlay, removeOutclickerOverlay, likechatEditModeOn, likechatEditModeOff } from './ChatBoxEditable.js';
import { miracleSync, resetChatItemExists, removeMiracleItemAnim } from './ChatSync.js';
import { initCrypter, getCryptId, runAutoDecrypt, chatDecrypt, forceSecureCrypt, processChatItemBeforeSend, processChatItemBeforeEdit } from './crypter.js';


const miracleState = {
    instance: null,
    editModeOn: false,
    $box: null
};
var cht2Param = {};

const miracleCommands = {
    closeMiracleForm: () => {
        miracleState.$box.val('');
        miracleState.$box.trigger('change', { forceupdate: true });

        $(window).trigger('jq-cht2fld-close', { noconnect: true, confirm: true, dontCloseMore: false });
    },
    closeMiracleOptions: () => {
        $(window).trigger('jq-miracle-option-menu', { action: 'close' });
    },

    miracleEdit: async (miracle) => {
        if (!miracle) return;

        await appState.globalCrypter.testTimeout();
        if (!appState.globalCrypter.ready) {
            await initCrypter({ from: 'crypt', skippable: false });
        }

        $('.floatingChat').each(function () {
            $(this).closest('[data-chat]').data('chat', miracle.id);
            $(this).find('.title-custom').html(miracle.title);

            const country = miracle.country || '0';
            const location = miracle.location || '0';
            $(this).attr('data-country', country).data('country', country);
            $(this).attr('data-location', location).data('location', location);
        });
        miracle.text = await chatDecrypt(miracle.text);
        var cleanEditText = await processChatItemBeforeEdit(miracle.text, 'miracle');
        miracleState.$box.data('original', {
            text: cleanEditText
        });

        ChatBoxEditable.startEditMode(() => {
            /* if (self.canStopEditMode()) {
                self.stopEditMode();
            } */
            // caur tejieni neizslēdzam edit mode;
            return false;
        });
        miracleState.$box.val(cleanEditText);
        miracleState.$box.trigger('change', { forceupdate: true });

        $(window).trigger('jq-cht2fld-open', { dontCloseMore: false, editMode: true, focusAfter: true });
    },

    miracleRemove: (id) => {
        removeMiracleItemAnim(id, id, true);
        resetChatItemExists();
    },

    miracleUpdate: async (miracle) => {
        const $chatItem = $('.chatItem[data-id="' + miracle.id + '"]');
        if (!$chatItem.length) {
            return;
        }

        if (miracle.text !== undefined) {
            const text = await chatDecrypt(miracle.text);
            $chatItem.find('.text').html(text);
        }

        if (miracle.title !== undefined) {
            // šis ir nešifrēts edited at laiks;
            $chatItem.find('.added .cht').attr('title', miracle.title || '');
        }

        if (miracle.name !== undefined) {
            miracle.name = await chatDecrypt(miracle.name);
            if (!miracle.name) {
                $chatItem.find('.name').remove();
            } else if (!$chatItem.find('.name').length) {
                $chatItem.find('.text').before($('<div class="name"></div>').html(miracle.name));
            } else {
                $chatItem.find('.name').html(miracle.name);
            }
        }

        if (miracle.locationTitle !== undefined && miracle.locationTitle !== null) {
            $chatItem.attr('data-location', miracle.locationTitle).data('location', miracle.locationTitle);
        }

        if (miracle.glow !== undefined) {
            $chatItem.attr('data-glow', miracle.glow > 0 ? 1 : 0).data('glow', miracle.glow > 0 ? 1 : 0);
        }
    },

    miracleTexts: (payload) => {
        if (!payload) return;

        if (payload.title) {
            $('.miracleTitle').html(payload.title);
        }
        if (typeof payload.count != 'undefined') {
            $('.ccmore').toggleClass('emptyList', payload.count == 0);
            $('.moreTx').toggleClass('emptyList', payload.count == 0);
            if (payload.count == 0) {
                $('.moreTx').css('display', 'block');
            }
        }
    },

    miracleSync: (payload) => {
        if (!payload) return;

        if (payload.items) {
            // te jāzin ir currentId - ar kuru ir interactions, lai zinātu ja sync ko pievieno, vai dzēš, lai skrolls iet uz augšu vai leju;'
            // un skipId - lai sync neapstrādā konkrētu id, piemēram, ja es tikko izveidoju un serveris atsūta atpakaļ manu pašu izveidoto ierakstu, tad es
            if (typeof miracleSync == 'function') {
                miracleSync(payload.items, payload.current, payload.except, true);
            }
        }
        if (payload.lastUpdated) {
            $('.chatParent').data('updated', payload.lastUpdated);
        }
    },
    //miraclesLastUpdated: (payload) => $('.chatParent').data('updated', payload)
};

const miracleChatActions = {
    'cht2fld-submit': async (data) => {
        var canceled = false;
        var result = await processChatItemBeforeSend(miracleState.$box.val(), 'miracle').catch((err) => {
            canceled = true;
        });
        if (canceled || !result || result.html == '') {
            return false;
        }

        data.addData = {
            ...(data.addData || {}),

            encrypted: 1,
            contains_emoji: result.contains_emoji,
            newChatItemHTML: result.html,
            length: result.length,

            location: $('.floatingChat').data('location'),
            country: $('.floatingChat').data('country'),
            favid: $('.floatingChat').data('favid')
        };
        return data;
    },
    'cht2fld-save': async (data) => {
        var canceled = false;
        var result = await processChatItemBeforeSend(miracleState.$box.val(), 'miracle').catch((err) => {
            canceled = true;
        });
        if (canceled || !result || result.html == '') {
            return false;
        }

        let original = miracleState.$box.data('original');

        data.addData = {
            ...(data.addData || {}),

            encrypted: 1,
            cht2id: data.chat,
            contains_emoji: result.contains_emoji,
            newChatItemHTML: result.html,
            length: result.length,
            textEdited: original && original.text != miracleState.$box.val() ? 1 : '',

            location: $('.floatingChat').data('location'),
            country: $('.floatingChat').data('country'),
            favid: $('.floatingChat').data('favid')
        };
        return data;
    },
    'cht2fld-discard-changes': (data) => {
        miracleState.$box.val('');
        miracleState.$box.trigger('change', { forceupdate: true });

        $(window).trigger('jq-cht2fld-close', { confirm: true });
        return false;
    },

    // poga iet uz miracle pievienošanu
    'cht2fld-new': async (data) => {
        const el = data.el;
        if ($(el).data('bk')) {
            lmAppStorage.saveBack('login', $(el).data('bk'));
            //document.dispatchEvent(new CustomEvent('app-storage:saveback', { detail: { key: 'login', url: $(el).data('bk') } }));
        }

        await $('.chat2add').animate({ opacity: 0 }, 300).promise();

        const connectMore = $('.connectMore').get(0);
        if ($(connectMore).hasClass('up')) {
            // @ts-ignore
            if (connectMore.moreToggler) {
                // @ts-ignore
                connectMore.moreToggler.hiddenBack(function () {
                    urlSafe.assign($(el).data('url'));
                });
                return false;
            }
        }
        urlSafe.assign($(el).data('url'));
        return false;
    },

    'cht2fld-menu': (data) => {
        $(window).trigger('jq-miracle-option-menu', { action: 'open', el: data.el, event: data.event });
        return false;
    },

    // menu pogas
    'cht2fld-info': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        return data;
    },
    'cht2fld-copy': (data) => {
        optionsMenu.copyAction(data.el, data.event);
        return false;
    },
    'cht2fld-edit': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        return data;
    },
    'cht2fld-glow': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        data.addData.on = $(data.el).hasClass('on') ? 0 : 1;
        return data;
    },
    'cht2fld-city': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        $(window).trigger('jq-miracle-option-menu', { action: 'close' });
        return data;
    },
    'cht2fld-title': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        return data;
    },
    // WMM statistikas lapas atvēršana no menu
    'cht2fld-wmm': (data) => {
        const cht2id = optionsMenu.currentBoxId() || 0;
        urlSafe.assign(getWMMUrl(cht2id));
        return false;
    },
    'cht2fld-wmm-orig': (data) => {
        const cht2id = optionsMenu.currentBoxId() || 0;
        urlSafe.assign(getWMMUrl(cht2id) + '&orig=1');
        return false;
    },

    'cht2fld-delete': (data) => {
        data.addData.cht2id = optionsMenu.currentBoxId() || 0;
        $(window).trigger('jq-miracle-option-menu', { action: 'close', el: $(data.el).closest('.cht2fld-options').get(0) });
        return data;
    },
    'cht2fld-deleteconfirm': (data) => {
        data.action = 'cht2fld-delete';
        data.addData = {
            ...(data.addData || {}),

            cht2id: $(data.el).data('id'),
            confirm: 1
        };
        return data;
    },

    // miracle ieraksta nosaukuma saglabāšana no modālās formas
    'cht2fld-title-save': async (data) => {
        data.addData.encrypted = 1;
        data.addData.cht2id = $(data.el).closest('[data-chat]').data('chat');
        var newName = getMiracleName($('.j-newname').val() || '');
        var canceled = false;
        var result = await processChatItemBeforeSend(newName, 'chatname').catch((err) => {
            canceled = true;
        });
        if (canceled) {
            return false;
        }
        if (!result || result.html == '') {
            data.addData.newName = newName;
        } else {
            data.addData.contains_emoji = result.contains_emoji;
            data.addData.newName = result.html;
        }
        return data;
    },

    // arhīva gada & mēneša atvēršana
    'cht2fld-year': (data) => {
        $(window).trigger('jq-cht2fld-year', { el: data.el, event: data.event });
        return false;
    },
    'cht2fld-month': (data) => {
        $(window).trigger('jq-cht2fld-month', { el: data.el, event: data.event });
        return false;
    },


    'cht2fld-citypop': (data) => {
        // te ņemam no attr lai ir no html, jo data mainīsies pēc popapa atvēršanas;
        // bet ja nav country, tad skatam data ja nu iepriekš jau bija izvēlēts kas;
        const attrMode = $('.floatingChat').attr('data-country') ? true : false;

        data.addData = {
            ...(data.addData || {}),

            cht2id: data.chat,
            forceLocation: attrMode ? $('.floatingChat').attr('data-location') : null,
            forceCountry: attrMode ? $('.floatingChat').attr('data-country') : null,
            favidux: attrMode ? $('.floatingChat').attr('data-favidux') : $('.floatingChat').data('favid'),

            selectLocation: $('.floatingChat').data('location'),
            selectCountry: $('.floatingChat').data('country')
        };
        return data;
    },
    'cht2fld-location-save': (data) => {
        data.addData = {
            ...(data.addData || {}),

            cht2id: data.chat,
            location: data.manualData?.location || 0,
            country: data.manualData?.country || 0,
            favId: data.manualData?.favId || 0
        };
        return data;
    },

};

var cht2Opened = false;


function initOpenMore() {
    var moreOpened = $('.connectMore').hasClass('up');
    const hanimate = $('.connectMore').data('h');

    var withFooter = false;

    var openMore = function () {
        $('.connectMore').toggleClass('up', true);

        $('.moreTx').css({
            opacity: 0,
            height: '',
            display: 'block'
        });

        /* if (withFooter) {
            $('footer').css({
                display: 'block'
            });
        } */
        scrollToElement($('.moreTx'), 120, 50);

        var animData = {};
        if (hanimate) {
            animData = {
                opacity: 1,
                height: $('.moreTx').height()
            };
            $('.moreTx').css({
                height: 0,
            });
        } else {
            animData = {
                opacity: 1
            };
        }

        $('.moreTx').animate(animData, 500, function () {

        });

        moreOpened = true;

        return true;
    };
    var closeMore = function () {
        $('.connectMore').toggleClass('up', false);

        $('.moreTx').animate({
            opacity: 0,
            height: 0
        }, 500, function () {
            $('.moreTx').css({
                display: 'none',
                height: ''
            });
            /* if (withFooter) {
                $('footer').css({
                    display: 'none'
                });
            } */
        });


        moreOpened = false;

        return true;
    };
    var moreToggler = new togglableUrl('view', openMore, closeMore, {
        addHistoryDelay: 500,
        scrollFix: true
    });
    // @ts-ignore
    $('.connectMore').get(0).moreToggler = moreToggler;

    $('body').on('click', '.openMore', function (event) {
        event.preventDefault();
        withFooter = $(this).data('showfooter') ? true : false;

        moreOpened = !moreOpened;
        if (moreOpened) {
            moreToggler.setOn();
        } else {
            moreToggler.setOff();
        }
    });

    $(window).on('jq-closeMore', function (event, param) {
        if (moreOpened) {
            moreOpened = false;
            moreToggler.setOff();

            $('.connectMore').toggleClass('up', moreOpened);
        }
    });
    if ($('.connectMore').hasClass('up')) {
        if (!isLoadedFromRefresh()) {
            const backStats = lmAppStorage.history.get('addscrollstats');
            if (backStats) {
                setScroll(backStats);
            } else {
                scrollToElement($('.moreTx'), 100, 50, 1);
            }
        }
    }
}

function getWMMUrl(cht2id) {
    // @ts-ignore
    return VarMgr.get('WMMURL', '') + '?wmmmiracle=' + cht2id;
}

// need in tpl


function hideConnectTx() {
    $('.connectTx').addClass('collapsed');
}

function openCht2(param) {
    hideConnectTx();

    $('.transAnimate').addClass('opening').removeClass('collapsed');
    $('body').addClass('cht2active');

    setTimeout(function () {
        animateCityTitle();
    }, 500);

    if (!param || !param.dontCloseMore) {
        $(window).trigger('jq-closeMore');
    }

    if (param && param.editMode) {
        ChatBoxEditable.startEditMode(() => {
            return false;
        });
        likechatEditModeOn();
    }

    const $overlay = createOutclickerOverlay();
    if ($overlay) {
        $overlay.on('click', function () {

        });
    }

    setTimeout(function () {
        $('.transAnimate').removeClass('opening');
        $('.miracleinputbox').prop('disabled', false);
        /* if (!mobileAndTabletCheck()) {
            $('.miracleinputbox').trigger('focus');
        } else if (param && param.focusAfter) {
            $('.miracleinputbox').trigger('focus');
        } */
        cht2AddHistoryOpened();
    }, 1000);
}

function closeCht2(param) {
    if ($('.transAnimate').hasClass('opening')) {
        return false;
    }

    if (!param) {
        param = {};
    }

    if (!param.fromhistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
        if (canCloseCht2(param)) {
            cht2Param = $.extend({}, param);
            appState.historyInstance.go(-1);
            return false;
        }
    }

    if (!canCloseCht2(param)) {
        setTimeout(function () {
            if (param.fromhistory) {
                cht2AddHistoryOpened();
            }

            if (typeof window['closeCht2AjaxPosting'] != 'undefined') {
                if (window['closeCht2AjaxPosting']) {
                    return false;
                }
            }
            window['closeCht2AjaxPosting'] = true;

            setTimeout(async function () {
                let pendingModalToken = null;
                let pendingModalReleased = false;
                let pendingModalTimeout = null;
                const releasePendingModalLock = function () {
                    if (pendingModalReleased) {
                        return;
                    }
                    pendingModalReleased = true;

                    if (pendingModalTimeout) {
                        clearTimeout(pendingModalTimeout);
                        pendingModalTimeout = null;
                    }

                    if (pendingModalToken && ModalManager) {
                        ModalManager.close(pendingModalToken);
                        pendingModalToken = null;
                    }
                };

                //ChatBoxEditable.stopEditMode();
                likechatEditModeOff();

                if (ModalManager) {
                    pendingModalToken = ModalManager.open({
                        name: 'connectEditCloseConfirmPending',
                        locksScroll: false
                    });
                    pendingModalTimeout = setTimeout(function () {
                        releasePendingModalLock();
                    }, 8000);
                }

                var sid = 0, id = 0, chat = 0;
                $('.floatingChat').each(function () {
                    sid = $(this).closest('[data-sid]').data('sid');
                    id = $(this).closest('[data-id]').data('id');
                    chat = $(this).closest('[data-chat]').data('chat');
                });

                var newChatItemHTML = '';
                var newChatItemLength = 0;
                var contains_emoji = 0;

                /* var canceled = false;
                var result = await processChatItemBeforeSend(miracleState.$box.val(), 'miracle').catch((err) => {
                    canceled = true;
                });
                if (canceled) {
                    return false;
                }

                if (result && result.html != '') {
                    newChatItemHTML = result.html;
                    newChatItemLength = result.length;
                    contains_emoji = result.contains_emoji;
                } */

                ajaxWrapNew({
                    method: 'POST',
                    data: {
                        ajax: 1,
                        action: 'cht2fld-closeConfirm',
                        sid: sid,
                        id: id,
                        chat: chat,
                        newChatItemHTML: newChatItemHTML,
                        length: newChatItemLength,
                        contains_emoji: contains_emoji,

                        syCurrent: chat,
                        updated: $('.chatParent').data('updated') || 0
                    },
                    success: async function (data) {
                        try {
                            await ResponseDispatcher.handle(data, 'cht2fld-closeConfirm');
                        } finally {
                            releasePendingModalLock();
                        }
                    },
                    complete: function () {
                        releasePendingModalLock();
                        window['closeCht2AjaxPosting'] = false;
                    },
                    dataType: 'json'
                });
            }, 0);
        }, 0);
        return false;
    }

    miracleState.$box.prop('disabled', true);
    $('.transAnimate').addClass('shutdown');
    setTimeout(function () {
        removeOutclickerOverlay();
        ChatBoxEditable.stopEditMode();
        likechatEditModeOff();
        $('.transAnimate').removeClass('shutdown').addClass('collapsed');
        $('body').removeClass('cht2active');
        if (!param.noconnect) {
            dispatchEvent(new CustomEvent('conn:showConnect'));
        }
    }, 1000);

    return true;
}

function canCloseCht2(param) {
    if (!param) {
        param = {};
    }
    if (!param.confirm && (miracleState.$box.val() != '' || $('.floatingChat').data('editmode'))) {
        if ($('.floatingChat').data('editmode')) {
            const orig = miracleState.$box.data('original');
            const newVal = miracleState.$box.val();
            if (orig) {
                if (orig.text != newVal && newVal != '') {
                    return false;
                } else {
                    return true;
                }
            }
        }
        return false;
    }

    return true;
}

function cht2AddHistoryOpened() {
    appState.historyInstance.push('cht2');
}

function setCht2Opened(opened) {
    cht2Opened = opened;
}
function isCht2Opened() {
    return cht2Opened;
}

function showLocationAnimation(options) {
    const $fld = $('<span class="citytitleAnimate">' + options.locationTitle + '</span>');
    $('.cty').append($fld);
    $fld.addClass('animate');

    setTimeout(function () {
        $fld.remove();
    }, 3000);
}

addEventListener('miracles:showLocationAnimation', function (e) {
    // Handle the event when the location animation should be shown
    // @ts-ignore
    showLocationAnimation(e.detail);
});

async function animateCityTitle() {
    //await decryptionDone();

    $('.floatingChat').first().each(function () {
        /* if ($(this).hasClass('animCityTitleDone')) {
            return;
        } */
        const locationTitle = $(this).attr('data-locationtitle');
        if (locationTitle) {
            showLocationAnimation({
                locationTitle: locationTitle
            });
            //$(this).addClass('animCityTitleDone');
            return;
        }
        const locationTitleAnim = $(this).attr('data-locationtitleanim');
        if (locationTitleAnim) {
            showLocationAnimation({
                locationTitle: locationTitleAnim
            });
            //$(this).addClass('animCityTitleDone');
        }
    });
};


const MIRACLE_NAME_MAXLEN = 77;
var getMiracleName = function (t) {
    let tx = (t || '');
    if (tx.length > MIRACLE_NAME_MAXLEN) {
        return tx.substring(0, MIRACLE_NAME_MAXLEN);
    }
    return tx;
};

function initMiracleOptions() {

    var resetUrlProps = function () {
        // ?yo=year,month,month2-year2,month2;
        var list = [];
        $('.archiveItem.year').not('.isclosed').each(function () {
            var year = $(this).data('year');
            var months = [];
            $('.archiveItemYear[data-year="' + year + '"]').not('.closed').each(function () {
                // archiveItem month isclosed closed
                $(this).find('.archiveItem.month[data-year="' + year + '"]').not('.isclosed').each(function () {
                    months.push($(this).data('month'));
                });
            });

            list.push(year + (months.length ? 'a' + months.join('a') : ''));
        });

        var year = $('.archiveItem').not('.year').not('.isclosed').first().data('year');
        if (year) {
            var months = [];
            // archiveItem month isclosed closed
            $('.archiveItem.month[data-year="' + year + '"]').not('.isclosed').each(function () {
                months.push($(this).data('month'));
            });

            list.push(year + (months.length ? 'a' + months.join('a') : ''));
        }

        var yo = list.join('-');
        setUrlParam('yo', yo || null);
    };
    $(window).on('jq-cht2fld-year', function (event, param) {
        var year = $(param.el).closest('.archiveItem').data('year');
        $('.archiveItemYear[data-year="' + year + '"]').each(function () {
            var open = $(this).hasClass('closed') ? true : false;
            $(param.el).closest('.archiveItem').toggleClass('isclosed', !open);
            if (open) {
                $(this).removeClass('closed');
                $(this).stop(true, false).animate({
                    height: $(this).find('.in').outerHeight()
                }, 500, 'swing', function () {
                    $(this).css('height', 'auto');
                });
                resetUrlProps();
            } else {
                $(this).stop(true, false).animate({
                    height: 0
                }, 500, 'swing', function () {
                    $(this).addClass('closed');
                    resetUrlProps();
                });
            }
        });
    });
    $(window).on('jq-cht2fld-month', function (event, param) {
        let year = $(param.el).closest('.archiveItem').data('year');
        let month = $(param.el).closest('.archiveItem').data('month');

        const toggleMonth = function ($it) {
            var open = $it.hasClass('closed') ? true : false;
            $(param.el).closest('.archiveItem').toggleClass('closed isclosed', !open);
            if (open) {
                $it.removeClass('closed isclosed');
                $it.stop(true, false).animate({
                    height: $it.find('.in').outerHeight()
                }, 500, 'swing', function () {
                    $(this).css('height', 'auto');
                });
                resetUrlProps();
            } else {
                $it.stop(true, false).animate({
                    height: 0
                }, 500, 'swing', function () {
                    $it.addClass('closed isclosed');
                    resetUrlProps();
                });
            }
        };
        let $it = $('.archiveItemMonth[data-year="' + year + '"][data-month="' + month + '"]');
        if ($it.length) {
            toggleMonth($it);
            return;
        }

        const self = param.el;
        ajaxWrapNew({
            method: 'POST',
            data: {
                ajax: 1,
                action: 'loadMiracles',
                year: year,
                month: month
            },
            success: function (data) {
                try {
                    ResponseDispatcher.handle(data, 'loadMiracles');
                    if (data.ok) {
                        if (data.miracles) {
                            var $it = $('<div class="archiveItemMonth closed" data-year="' + year + '" data-month="' + month + '"></div>').append(
                                $('<div class="in"></div>').append(data.miracles)
                            );

                            $(self).closest('.archiveItem').after($it);

                            runAutoDecrypt($it).then(() => {
                                toggleMonth($it);
                                minimizableInit($it.get(0));
                            });
                        }
                    }
                } catch (e2) {
                    console.log(e2);
                }
            },
            dataType: 'json'
        });
    });

    $(window).on('jq-miracle-option-menu', function (event, param) {
        if (param.action == 'open') {
            optionsMenu.open(param);
        }
        if (param.action == 'close') {
            optionsMenu.close(param);
        }
    });
}
function bindMiracleEvents() {
    $('body').on('click', '.mmIconLink', function (event) {
        event.preventDefault();

        let stars = $(this).data('stars') || 0;
        // @ts-ignore
        if (typeof connectChatLinks !== 'undefined') {
            // @ts-ignore
            if (connectChatLinks[stars]) {
                // @ts-ignore
                urlSafe.assign(connectChatLinks[stars]);
            }
        }
    });
}


const initMiraclePage = function () {
    const self = this;

    self.isRepost = false;

    const $chatbox = $('.miracleinputbox');
    miracleState.$box = $chatbox;


    CommandRegistry.registerCommands(miracleCommands);
    ActionSets.registerSet('miracleChatActions', miracleChatActions);

    optionsMenu.addOpenFilter(function (tpl, el) {
        if ($(tpl).hasClass('ismiracles')) {
            const $item = $(el).closest('.chatItem');
            const wmmVisible = $item.data('wmm') || 0;
            const wmmCity = $item.data('location') || '';
            const glowOn = $item.data('glow') || 0;
            if (wmmVisible > 0) {
                $(tpl).find('.cht2fld-wmm')
                    .toggle(true)
                    .toggleClass('islocked', $item.data('locked') || false);
            } else {
                // tomēr lai rāda visiem
                $(tpl).find('.cht2fld-wmm')
                    .toggle(true)
                    .toggleClass('islocked', false);
            }
            $(tpl).find('.btn-glow').toggleClass('on', glowOn > 0);

            if (wmmCity.length > 0) {
                let wmmCityParts = wmmCity.split('|');
                wmmCityParts[0] = '<span class="ln">' + wmmCityParts[0] + '</span>';
                if (wmmCityParts.length > 1) {
                    wmmCityParts[1] = '<span class="lnfx"><span class="a">(</span><span class="b">' + wmmCityParts[1] + '</span><span class="a">)</span></span>';
                }
                let wmmCityHtml = wmmCityParts.join('<br>');
                $(tpl).find('.cht2fld-city').find('button').html(wmmCityHtml).end().toggle(true);
            }
        }
    });

    optionsMenu.addCopyHandler(function (text, box) {
        const $name = $(box).find('.name');
        if ($name.length) {
            $name.each(function () {
                text.push(optionsMenu.cleanText(this));
            });
            text.push("\n");
        }

        $(box).find('.text').each(function () {
            text.push(optionsMenu.cleanText(this));
        });
    });



    self.miracleAction = async function (act) {
        if (!act) {
            return;
        }
        //action, sid, id, chat, iscustom, el, event, manualData = {}
        const origArguments = arguments;

        var addData = {};

        if ($(act.el).data('addtag')) {
            let addTag = $(act.el).data('addtag');
            addData[addTag] = 1;
        }
        var after = null;
        try {
            const actionData = {
                action: act.action,
                sid: act.sid,
                id: act.id,
                chat: act.chat,
                iscustom: act.iscustom,
                el: act.element,
                event: act.event,
                manualData: act.manualData || {},
                addData: addData
            };

            const result = await ActionSets.handleAction(act.action, actionData);
            if (result === false) {
                return;
            }
            if (result && typeof result === 'object') {
                if (result.action) {
                    act.action = result.action;
                }
                if (result.addData) {
                    Object.assign(addData, result.addData);
                }
            }
        } catch (e) {
            console.log('Error occurred while processing chat action:', e.message);
            console.warn(e);
            return;
        }

        if (addData?.encrypted) {
            addData.cryptId = getCryptId();
        }

        const ajaxData = $.extend({
            ajax: 1,
            action: act.action,
            sid: act.sid,
            id: act.id,
            chat: act.chat,
            time: getUserTime(),

            syCurrent: addData.cht2id || 0,
            updated: $('.chatParent').data('updated') || 0
        }, addData);

        if (typeof window['chtActionAjaxPosting'] != 'undefined') {
            if (window['chtActionAjaxPosting']) {
                return false;
            }
        }
        window['chtActionAjaxPosting'] = true;
        ajaxWrapNew({
            method: 'POST',
            data: ajaxData,
            success: async function (data) {
                try {
                    if (data.repost) {
                        if (self.isRepost) {
                            throw new Error('Repost failed');
                        }
                        await ResponseDispatcher.handle(data, act.action + '-repost');

                        self.isRepost = true;
                        self.miracleAction(...origArguments);
                        return false; // apturam pārējās darbības;
                    }

                    self.isRepost = false;
                    await ResponseDispatcher.handle(data, act.action);

                    if (data.ok) {
                        after && after(data);
                    }
                } catch (e2) {
                    console.log(e2);
                }
            },
            complete: function () {
                window['chtActionAjaxPosting'] = false;
            },
            dataType: 'json'
        });
    };


    $('body').on('click.cht', '.cht', function (event) {
        if ($(this).is('a')) {
            event.preventDefault();
        }

        event.stopPropagation();

        if ($(this).hasClass('no-action') && !(event && event.originalEvent instanceof MouseEvent && event.originalEvent.ctrlKey)) {
            return;
        }

        var sid = 0, id = 0, chat = 0;
        $('.floatingChat').each(function () {
            sid = $(this).closest('[data-sid]').data('sid');
            id = $(this).closest('[data-id]').data('id');
            chat = $(this).closest('[data-chat]').data('chat');
        });

        self.miracleAction({
            action: $(this).data('action'),
            sid: sid, // sid
            id: id, // iid
            chat: chat, // miracle id;
            element: this,
            event: event
        });
    });

    $('.floatingChat').on('callMiracleAction', function (event, action, data) {
        event.stopPropagation();

        var sid = 0, id = 0, chat = 0, iscustom = '';
        $('.floatingChat').each(function () {
            sid = $(this).data('sid');
            id = $(this).data('id');
            chat = $(this).data('chat');
            iscustom = $(this).data('iscustom');
        });

        id = data.chat || chat;
        chat = data.chat || chat;

        self.miracleAction({
            action: action,
            sid: sid,
            id: id,
            chat: chat,
            iscustom: iscustom,
            element: this,
            event: event,
            manualData: data
        });
    });

    // čata input containera klikšķis
    $('body').on('click.cht', '.chat-i', function (event) {
        event.stopPropagation();

        if (document.activeElement != $chatbox.get(0)) {
            $chatbox.trigger('focus');
            return;
        }
    });

};

var initConnectChatPage_done = false;
function initConnectChatPage() {
    if (initConnectChatPage_done) {
        return;
    }
    initConnectChatPage_done = true;

    var cancelNextOutClick = false;
    var isChatOpenned = VarMgr.get('isChatOpenned', false);

    $('body').on('click', '.cht2fld', function (event) {
        event.stopPropagation();

        if ($(this).data('url')) {
            location.assign($(this).data('url'));
            return;
        }

        setUrlParam({
            country: false,
            city: false
        });

        setTimeout(function () {
            setCht2Opened(true);
        }, 1000);
        openCht2();
    });

    $('body').on('mousedown', '.miracleinputbox', function (event) {
        event.stopPropagation();
        cancelNextOutClick = true;
    });
    $('body').on('mouseup', '.miracleinputbox', function (event) {
        cancelNextOutClick = false;
    });

    var cancelClick = false;

    $('body').on('mousedown', function (event) {
        if ($('.transAnimate').hasClass('opening')) {
            cancelClick = true;
        }
    });
    $('body').on('click', function (event) {
        if (cancelClick) {
            cancelClick = false;
            event.preventDefault();
            event.stopPropagation();
        }
    });

    $('body').on('click', '.floatingChat', function (event) {
        event.stopPropagation();
    });

    $('body').on('mouseup', '.floatingChat', function (event) {
        cancelNextOutClick = false;
    });
    $('body').on('dragend', '.floatingChat', function (event) {
        cancelNextOutClick = false;
    });

    $(window).on('jq-cht2fld-open', function (event, param) {
        if (!isCht2Opened()) {
            forceSecureCrypt(true).then(() => {
                setTimeout(function () {
                    setCht2Opened(true);
                }, 1000);
                openCht2(param);
            });
        }
    });

    $(window).on('jq-cht2fld-close', function (event, param) {
        if (isCht2Opened()) {
            if (closeCht2(param)) {
                setCht2Opened(false);
            }
        } else if (param && param.fromhistory) {
            setTimeout(function () {
                cht2AddHistoryOpened();
                ajaxWrapNew({
                    method: 'POST',
                    data: {
                        ajax: 1,
                        action: 'cht2fld-reload',
                    },
                    success: function (data) {
                        ResponseDispatcher.handle(data, 'cht2fld-reload');
                    },
                    dataType: 'json'
                });
            }, 100);
        }
    });

    $('.floatingChat').on('changeLocation', function (event, data) {
        $(this).trigger('callMiracleAction', ['cht2fld-location-save', data]);
    });


    $('body').on('click', '.edcht2', function (event) {
        event.stopPropagation();
    });


    $(window).on('jq-outclick.tmr', function (event) {
        if (cancelNextOutClick) {
            cancelNextOutClick = false;
            return;
        }
        if (isCht2Opened()) {
            if (closeCht2()) {
                //ChatBoxEditable.stopEditMode();
                setCht2Opened(false);
            }
        }
    });


    appState.historyInstance.add('cht2', {
        value: null,
        backCallback: function (change) {
            setTimeout(function () {
                $(window).trigger('jq-cht2fld-close', $.extend({}, cht2Param, { fromhistory: true }));
            }, 0);
        },
        checkCallback: function (value) {
            return isCht2Opened() ? true : null;
        },
        goBackOnRefresh: true
    });

    if (isChatOpenned) {
        animateCityTitle();
    }


    if (isChatOpenned) {
        setUrlParam('openmiracle', false);
        setTimeout(function () {
            setCht2Opened(true);
            $('.miracleinputbox').prop('disabled', false);

            cht2AddHistoryOpened();

            /* if (!mobileAndTabletCheck()) {
                $('.miracleinputbox').trigger('focus');
            } */
        }, 100);
    }
};



export function loadMiracles() {

    var miracleOptionsInit = false;

    // miracle/connect čata logs;
    if ($('textarea.miracleinputbox').length) {
        bindMiracleEvents();

        miracleState.instance = new initMiraclePage();
        ChatBoxEditable.init({
            selector: '.miracleinputbox',
        })
        miracleOptionsInit = true;
    }

    if ($('.connectMore').length) {
        initOpenMore();
    }

    // miracle/connect
    if ($('.connectchat').length) {
        initConnectChatPage();
        miracleOptionsInit = true;
    }

    if (miracleOptionsInit) {
        initMiracleOptions();
    }

    if (typeof minimizableInit !== 'undefined') {
        minimizableInit(document);
    }
}

export function loadForConnect() {
    initConnectChatPage();
}
